import { OptionalAppRoute } from '../types';
import { createRelativeUrl, stripAnyAppPrefixFromUrl } from '../utils';

const providerIdsByOrigin: Record<string, string> = {
    'https://lumapps-demo.beekeeper.io':
        'https://login.lumapps.com/v1/saml2/sp/4930449491099648/83ba8914-df40-4279-89fb-dc3ca98dbfbf',
    'https://pmi-backend.dev.beekeeper.io':
        'https://login.dev.lumapps.com/v1/saml2/sp/1491690978291201/b0b526a1-0245-4071-91f0-ecfc1d7091d2',
};

// Temporary authenticated link, for demo purposes only
const createAuthenticatedLink = (target: string) => {
    return `${window.location.origin}/auth_link?bkpr-embedded-integration=true&entity_id=${
        providerIdsByOrigin[window.location.origin]
    }&target=${target}?bkpr-embedded-integration=true&bkpr-micro-app=true
`;
};

const createUrl = (route: OptionalAppRoute) => {
    const currentOrigin = window.location.origin;
    const relativeUrl = createRelativeUrl({
        ...route,
        query: {
            site: route.instanceSlug,
        },
    });

    // To be removed once we have finished the demo and the beekeeper mobile app manages token exchange
    if (Object.keys(providerIdsByOrigin).includes(currentOrigin)) {
        return createAuthenticatedLink(`${window.LumappsContext.tenantUrl}${relativeUrl}`);
    }

    const urlWithoutAppPrefix = stripAnyAppPrefixFromUrl(relativeUrl);

    if (window.BeekeeperRouterBridge && route.appId) {
        const url = route.externalAppId ? urlWithoutAppPrefix : `/la${urlWithoutAppPrefix}`;
        return window.BeekeeperRouterBridge?.getUrl?.(route.appId, url) || url;
    }

    const lumappsUrl = `${window.LumappsContext.tenantUrl}${urlWithoutAppPrefix}`;

    return lumappsUrl;
};

export const webComponentsRouterApi = {
    redirect: (route: OptionalAppRoute) => {
        const url = createUrl(route);

        if (window.BeekeeperRouterBridge && url) {
            window.BeekeeperRouterBridge.push(url);
        }
    },
    getUrl: createUrl,
};
